<template>
  <div class="formTop page_date_top">
    <div class="topNav">
      <div class="dateSelect">
        <div>
          <ShowNavHead />
        </div>
        <div class="dateSelectNav">
          <div class="dateType" v-for="(dateT,index) in dateTypeSelect" :key="index" v-bind:class="{selected:isActive==index}" @click="checkItem(dateT,index)" :style="'width:' +(dateT.name == '自定义日期'?'80px':'44px')">{{dateT.name}}</div>
        </div>
        <div class="exactDate" v-show="isActive=='3'&&dateTypeName=='自定义日期'">
          <div class="block">
            <el-date-picker v-model="customDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false" unlink-panels @change="selectCustom"></el-date-picker>
          </div>
        </div>
        <div class="exactDate" v-show="dateTypeName != '自定义日期'">
          <div class="fast-switch" @click="fastWwitch('')"><i class="el-icon-arrow-left"></i></div>
          <div class="block ssdate" v-show="isActive=='0'">
            <el-date-picker style="width:130px" v-model="dateVal" type="date" placeholder="选择日期" :clearable="false" :picker-options="pickerOptions" value-format="yyyy-MM-dd" @change="selectDay"></el-date-picker>
          </div>
          <div class="block ssdate" v-show="isActive=='1'">
            <el-date-picker style="width:130px" v-model="dateVal" type="week" format="yyyy 第 WW 周" placeholder="选择周" :clearable="false" :picker-options="pickerOptionsWeek" @change="setWeekNum"></el-date-picker>
          </div>
          <div class="block ssdate" v-show="isActive=='2'">
            <el-date-picker style="width:130px" v-model="dateVal" type="month" placeholder="选择月" :picker-options="pickerOptionsMonth" value-format="yyyy-MM" :clearable="false" @change="selectMonth"></el-date-picker>
          </div>
          <div class="fast-switch" @click="fastWwitch(1)"><i class="el-icon-arrow-right"></i></div>
        </div>
        <el-input size="small" v-model="listQuery.projectname" placeholder="请输入项目名称" style="width: 180px;"></el-input>
        <div class="screenInput cp" style="margin: 0 0 0 10px;">
          <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
            <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
          </el-tooltip>
        </div>
        <button class="exportButton" style="margin-left:5px" @click="searchEnterFun" v-show="showDropScreen!=1">搜索</button>
        <!-- <button class="reset" @click="resetForm()">清空</button> -->
        <div class="sels-box">
        </div>
      </div>
      <div class="screenAndExport">
        <div>
          <!-- <button class="exportButton" v-if="hasRefresh" style="width: 100px;margin-right:20px">刷新报表</button> -->
          <!-- 运营效能表 -->
          <el-button v-if="pathname == 'report'" class="exportButton" style="margin-right:20px" :loading="btnLoading" @click="exportInfo" :disabled="(listData==[]||listData.length<=0)">导出</el-button>
          <!-- 招聘效能表 -->
          <el-button v-if="pathname == 'recruit'" class="exportButton" style="margin-right:20px" :loading="btnLoading" @click="exportInfo" :disabled="(listData==[]||listData.length<=0)">导出</el-button>
        </div>
      </div>
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="pro_down_box">
          <el-form :inline="true" :model="listQuery" class="pro_down_form" label-width="120px">
            <!-- <el-form-item label="服务部门:">
              <el-select v-model="listQuery.bm" filterable clearable>
                <el-option v-for="(item, index) in departList" :key="index+'d'" :label="item.Strorganname" :value="item.StrDep2">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="客服:">
              <el-select v-model="listQuery.strservuserid" filterable clearable>
                <el-option v-for="(item, index) in customerList" :key="index+'d'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合伙人:">
              <el-select v-model="listQuery.strpartner2" filterable clearable>
                <el-option v-for="(item, index) in partnerList" :key="index+'a'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业绩归属人:">
              <el-select v-model="listQuery.strAchieveowner" filterable clearable>
                <el-option v-for="(item, index) in partnerList" :key="index+'a'" :label="item.Username" :value="item.Userid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
          <button class="reset" @click="resetForm()">清空</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
          <button class="exportButton" style="margin-left:10px" @click="searchEnterFun">搜索</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    parseTime
  } from '@/utils' //格式化时间格式
  export default {
    props: {
      listData: {
        type: Array // 定义接收到的数据的类型
      },
      pathname: {
        type: String // 是哪个页面的'report'
      }
    },
    components: {
      parseTime
    },
    data() {
      return {
        hasRefresh: false, //刷新按钮
        roletype: localStorage.loginRoletype,
        weekNum: "",
        weekVal: "",
        isActive: 2,
        date: null,
        showMonthOrYear: "",
        btnLoading: false,
        //下拉筛选
        showDropScreen: -1,
        //导出
        dialogVisible4: false,
        dateTypeSelect: [{
            name: "日",
            value: 3
          },
          {
            name: "周",
            value: 2
          },
          {
            name: "月",
            value: 1
          }
          // {
          //   name: "自定义日期",
          //   value: 4
          // }
        ],
        //列表参数
        listQuery: {
          p_userid: Cookies.get("userid-b"),
          p_currpage: 1,
          p_pageNum: 10,
          p_lvl: 1, // 1按月，2按周，3按自选时间
          starttime: '',
          endttime: '',
          projectname: '', //项目名称
          strAchieveowner: '', //业绩归属人
          strpartner2: '', //合伙人
          businesstype: '', //业务
          strservuserid: '', //客服
          p_grouytype: 5,
          keyname:'',
          orderby: [],
          bm: ''
        },
        dateVal: '',
        customDate: '',
        dedpartNameList: '',
        // 部门列表
        departList: [],
        // 自定义 级联选择props
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        query: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: ""
        },
        customerList: [],
        partnerList: [],
        exportQuery: {
          perpage: 100000,
          currpage: 1,
          strdatetype: "month",
          strdate: "",
          strsrvcent: "",
        },
        permissionLists:[],
        dateVals: '',
        //禁用日期范围
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        //禁用日期范围周
        pickerOptionsWeek: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 24 * 60 * 60 * 1000 * 7;
          },
          'firstDayOfWeek': 1
        },
        //禁用日期范围月
        pickerOptionsMonth: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 24 * 60 * 60 * 1000 * 31;
          }
        },
        //选择的type名称
        dateTypeName: '月'
      };
    },
    async created() {
      this.dateVal = new Date();
      if (this.dateTypeName != '自定义日期') {
        this.getTimeSet()
      }
      // this.$emit('fatherMethod', this.listQuery);

      let tab = JSON.parse(localStorage.tableids);
      if (tab && tab != undefined && tab.length > 0) {
        tab.forEach((element, index) => {
          element.Strroletable = element.Strroletable + '2';
          if (element.StrroleName == '利润表刷新') {
            this.hasRefresh = true;
          }
        });
      }
    },
    mounted() {
      if (this.dateTypeName != '自定义日期') {
        this.dateVals = parseTime(new Date(this.dateVal), '{y}-{m}-{d}')
        // console.log('dateVals',this.dateVals)
        this.fastWwitch('');
      }
    },
    methods: {
      checkPermission,
      //搜索
      searchEnterFun() {
        this.showDropScreen = -1;
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      //清空
      resetForm() {
        this.listQuery.projectname = '';
        this.listQuery.strAchieveowner = ''; //业绩归属人
        this.listQuery.strpartner2 = ''; //合伙人
        this.listQuery.businesstype = ''; //业务
        this.listQuery.strservuserid = ''; //客服
        this.listQuery.strAchieveowner = '';//业绩归属人
        // if (this.dateTypeName != '自定义日期') {
        //   this.dateVals = parseTime(new Date(this.dateVal), '{y}-{m}-{d}')
        //   this.getTimeSet()
        // }
      },
      // 上/下一天/周/月
      async fastWwitch(add) {
        switch (this.isActive) {
          case 0: //日
            this.dateVals = add === 1 ? this.getDay(1, '-') : this.getDay(-1, '-');
            break;
          case 1: //周
            this.dateVals = add === 1 ? this.getDay(7, '-') : this.getDay(-7, '-');
            break;
          case 2:
            this.dateVals = add === 1 ? this.getNextMonth(this.dateVals) : this.getPreMonth(this.dateVals);
            break;
        }
        // console.log('a0',this.dateVals,add,this.dateVal)
        this.dateVal = this.dateVals
        this.getTimeSet()
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      //日期类型选择
      checkItem(dateT, index) {
        // console.log('日期类型',dateT)
        this.isActive = index;
        this.dateTypeName = dateT.name
        this.listQuery.p_lvl = dateT.value;
        // this.$emit('event2', index)
        if (this.dateTypeName != '自定义日期') {
          this.dateVal = new Date()
          this.dateVals = parseTime(new Date(this.dateVal), '{y}-{m}-{d}')
          this.fastWwitch('');
          this.getTimeSet()
        } else {
          this.defaultDate()
        }
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      async selectDay(date) {
        // console.log("selectDay", date);
        this.dateVal = date;
        this.listQuery.starttime = date;
        this.listQuery.endttime = date;
        this.dateVals = parseTime(new Date(this.dateVal), '{y}-{m}-{d}')
        this.showMonthOrYear = 0;
        // this.$emit('event2', this.showMonthOrYear)
        this.getTimeSet()
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      async setWeekNum(date) {
        // console.log("setWeekNum", date);
        this.dateVal = date;
        this.dateVals = parseTime(new Date(this.dateVal), '{y}-{m}-{d}')
        var moment = require("moment");
        //注意，当返回值是中国标准时间的格式时使用moment.js的时候一定要加上.utcOffset(480)，用来转换时区
        // console.log(date);
        var a = date.toString().substring(11, 15);
        // console.log('a',a);
        //  a.substring(11,14)
        this.weekVal =
          a +
          "-" +
          moment(this.date)
          .utcOffset(480)
          .format("WW");
        this.showMonthOrYear = 1;
        // this.$emit('event2', this.showMonthOrYear)
        this.getTimeSet()
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      async selectMonth(date) {
        // console.log("selectMonth", date);
        // this.dateVals = date             
        this.dateVal = date;
        this.dateVals = parseTime(new Date(this.dateVal), '{y}-{m}-{d}')
        this.showMonthOrYear = 2;
        // this.$emit('event2', this.showMonthOrYear)
        this.getTimeSet()
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      async selectCustom(date) {
        // console.log("selectCustom", date);
        this.customDate = date;
        this.showMonthOrYear = 3;
        // this.$emit('event2', this.showMonthOrYear)
        this.listQuery.starttime = date[0]
        this.listQuery.endttime = date[1]
        this.listQuery.orderby = this.$parent.orderArray;
        this.$emit('fatherMethod', this.listQuery);
      },
      //时间取值
      async getTimeSet() {
        // 0天  1周  2月
        const baseTime = this.dateVal
        const dateMoments = new Date(baseTime)
        const monthFirstDates = dateMoments.getFullYear() + '-' + (dateMoments.getMonth() + 1) + '-01'
        // console.log('月第一天',monthFirstDates)
        let startTimes = dateMoments.toLocaleDateString().split('/')
        // console.log('开始时间',startTimes)
        const weekDates = new Date(dateMoments.getFullYear(), dateMoments.getMonth(), dateMoments.getDate() - dateMoments.getDay() + 1).toLocaleDateString().split('/')
        // console.log('周开始时间',weekDates)
        const weekLastDays = new Date(dateMoments.getFullYear(), dateMoments.getMonth(), dateMoments.getDate() - dateMoments.getDay() + 7).toLocaleDateString().split('/')
        // console.log('周最后时间',weekLastDays)
        const monthDates = new Date(Number(startTimes[0]), Number(startTimes[1]), 0).toLocaleDateString().split('/')
        // console.log('月时间',monthDates)
        if (this.isActive == '0') {
          this.listQuery.starttime = this.dateVal
          this.listQuery.endttime = this.dateVal
          this.customDate = [this.dateVal, this.dateVal]
          // console.log('日',this.listQuery.date)
        }
        if (this.isActive == '1') {
          this.listQuery.starttime = weekDates.join('-')
          this.listQuery.endttime = weekLastDays.join('-')
          this.customDate = [weekDates.join('-'), weekLastDays.join('-')]
        }
        if (this.isActive == '2') {
          this.listQuery.starttime = monthFirstDates
          this.listQuery.endttime = monthDates.join('-')
          this.customDate = [monthFirstDates, monthDates.join('-')]
        }
        // 处理日期超时
        if (new Date(this.listQuery.starttime).getTime() > new Date().getTime()) {
          this.listQuery.starttime = new Date().toLocaleDateString().split('/').join('-')
        }
        if (new Date(this.listQuery.endttime).getTime() > new Date().getTime()) {
          this.listQuery.endttime = new Date().toLocaleDateString().split('/').join('-')
        }
        // 格式化时间
        this.listQuery.starttime = parseTime(new Date(this.listQuery.starttime), '{y}-{m}-{d}')
        this.listQuery.endttime = parseTime(new Date(this.listQuery.endttime), '{y}-{m}-{d}')
        this.customDate = [this.listQuery.starttime, this.listQuery.endttime]
        // console.log('时间', this.listQuery.starttime, this.listQuery.endttime)
      },
      exportInfo() {
        this.btnLoading = true;
        let data = this.$parent.listQuery;
        let p_pageNum = this.$parent.listQuery.p_pageNum;
        let activeName = this.$parent.activeName + data.p_grouytype;
        if(this.$parent.activeName == 'ProfitListRecrCounselor'){
          if (this.$parent.p_grouytype <= 4) {
            activeName = this.$parent.activeName;
          }
        }
        if(this.$parent.p_grouytype == 0){
          activeName = this.$parent.activeName == 'ProfitListRecrChannel' ? this.$parent.activeName + 3 : this.$parent.activeName == 'ProfitListRecrEfficiency' || this.$parent.activeName == 'ProfitListRecrProjEffic' ? this.$parent.activeName + 7 : this.$parent.activeName;
        }
        this.$set(data,'currmon','');
        this.$set(data,'p_currpage',1);
        this.$set(data,'p_pageNum',100000);
        xz.gettestreport('downloadreport', activeName, data).then(res => {
        if (res.status == 'ok') {
          this.$router.push({
            path: '/employee-exportRecordList'
          })
        } else {
          this.$message({
            message: "导出错误",
            type: "error"
          })
        }
        this.$set(data,'p_pageNum',p_pageNum);
        this.btnLoading = false;
      })
        // this.exportQuery.strdatetype = this.listQuery.strdatetype
        // this.exportQuery.strdate = this.listQuery.strdate
        // this.exportQuery.strsrvcent = this.listQuery.strsrvcent
        // this.exportQuery.currpage = 1
        // console.log("exportQuery", this.exportQuery);
        // xz.reportCurrDataTable('员工统计', this.listQuery.strsrvcent, this.listQuery.strdatetype, this.listQuery.strdate, this.exportQuery).then(res => {
        //   console.log("reportCurrDataTable", res);
        //   if (res.status == 'ok') {
        //     this.btnLoading = false;
        //     this.$router.push({
        //       path: '/employee-exportRecordList',
        //       query: {
        //         custname: res.msg,
        //         isReport: true
        //       }
        //     })
        //   } else {
        //     this.btnLoading = false;
        //     this.$message({
        //       message: "导出错误",
        //       type: "error"
        //     })
        //   }
        // });
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
          if (this.customerList.length == 0) {
            // 获取部门列表
            this.getScreenList('getrecrrservicesdepart', 'departList');
            // 客服
            this.getScreenList('getrecrrservicesr', 'customerList');
            // 合伙人
            this.getMemberList();
          }
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //设置默认日期（自定义日期）
      defaultDate() {
        //获取新的时间
        let date = new Date() - 24 * 60 * 60 * 1000;
        date = new Date(date);
        //获取当前时间的年份转为字符串
        let year = date.getFullYear().toString();
        //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果 是在字符串前面拼接‘0’
        let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        //获取天，判断是否小于10，如果 是在字符串前面拼接‘0’
        let da = date.getDate() < 10 ? '0' + (date.getDate()).toString() : (date.getDate()).toString();
        //字符串拼接，开始时间，结束时间
        let end = year + '-' + month + '-' + da; //当天
        let beg = year + '-' + month + '-01'; //当月第一天
        this.customDate = [beg, end];
        this.listQuery.strdate = this.customDate.toString();
        this.listQuery.starttime = beg;
        this.listQuery.endttime = end;
      },
      // 获取昨天和明天
      getDay(num, str) {
        var today = new Date(this.dateVals);
        var nowTime = today.getTime();
        var ms = 24 * 3600 * 1000 * num;
        today.setTime(parseInt(nowTime + ms));
        var oYear = today.getFullYear();
        var oMoth = (today.getMonth() + 1).toString();
        if (oMoth.length <= 1) oMoth = '0' + oMoth;
        var oDay = today.getDate().toString();
        if (oDay.length <= 1) oDay = '0' + oDay;
        return oYear + str + oMoth + str + oDay;
      },
      /**
       * 获取上一个月
       * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
       */
      getPreMonth(date) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中月的天数
        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = '0' + month2;
        }
        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
      },
      /**
       * 获取下一个月
       * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
       */
      getNextMonth(date) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中的月的天数
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = '0' + month2;
        }
        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
      },
      // 获取部门列表
      getScreenList(pagename, list) {
        xz.getrecrrservicesdepart(pagename, '0383e791-72fd-4edc-aa70-2bcadminuser').then(res => {
          if (res.status == 'ok') {
            this[list] = res.data;
          } else {
            this[list] = [];
          }
        })
      },
      //取合伙人列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.query).then(res => {
          if (res.status == 'ok') {
            this.partnerList = res.msg;
          } else {
            this.partnerList = []
          }
        })
      },
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* .screenAndExport{
   margin-right: 50px;
 } */
  /* .page_date_top .dateSelectNav {
    width: 212px;
  } */

  .page_date_top .el-date-editor--daterange.el-input__inner {
    width: 235px !important;
    margin-right: 5px;
  }

  .page_date_top .el-date-editor .el-range__close-icon {
    display: none;
  }

  .formTop .el-date-editor.el-input {
    width: 170px;
  }

  .top-right {
    display: flex;
    align-items: center;
  }

  .top-right .el-button--text {
    padding: 7px 10px;
    border: solid 1px #19BD92;
    font-size: 12px;
    color: #19BD92;
    border-radius: 4px;
    background-color: #fff;
  }

  .top-right .el-button--text img {
    vertical-align: sub;
  }

  .reset {
    height: 32px;
    padding: 5px 15px;
    border-radius: 5px;
    color: #B2BCB7;
    background-color: #fff;
    border: 1px solid #B2BCB7;
    margin-right: 10px;
  }

  .screenAndExport .exportButton {
    height: 32px;
    padding: 5px 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #19BD92;
    border: 1px dashed #19BD92;
    color: #fff;
  }

  .screenAndExport {
    align-items: center;
    -webkit-align-items: center;
  }

  .pro_down_box {
    padding-top: 15px;
  }
</style>

<style>
  .titleAndButton .exportButton {
    height: 32px;
    padding: 5px 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #19BD92;
    border: 1px dashed #19BD92;
    color: #fff;
  }

  .exactDate {
    display: flex;
  }

  .sels-box .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

  .exactDate .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

  .exactDate .el-input__icon {
    line-height: 32px;
  }

  .sels-box .el-input__icon {
    line-height: 32px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .screenAndExport .el-button {
    padding: 0;
    margin-right: 20px;
  }

  .dialog .el-dialog__header {
    padding: 0;
  }

  .dialog .el-dialog__body {
    padding: 20px 20px 0 20px;
  }

  .storageInput .el-input--small .el-input__inner {
    width: 368px;
    height: 32px;
  }

  .storageInput .el-input--small {
    width: 360px;
  }

  .pro_down_box .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .ssdate .el-input--suffix .el-input__inner{
    padding-right: 10px;
  }
</style>